import { HTMLAttributes } from "react";
import classNames from "clsx";

import { FiEdit } from "react-icons/fi";

import { useThemeMode } from "@/../_metronic/partials";
import { SaveButton } from "@/components/Buttons/SaveButton";

type ActionButtonProps = {
	isEditing: boolean;
	setIsEditing: (value: boolean) => void;
	data: Attendance | Patient;
	handleUpdateData: () => void;
	hasSomeBlankField: boolean;
};

type ButtonProps = HTMLAttributes<HTMLButtonElement>;

export function ActionButton({
	isEditing,
	setIsEditing,
	data,
	handleUpdateData,
	hasSomeBlankField,
}: ActionButtonProps) {
	const { mode } = useThemeMode();

	function EditButton({ ...rest }: ButtonProps) {
		return (
			<button
				className={classNames(
					"btn shadow hover-elevate-up px-4 py-2 text-primary",
					mode === "dark" ? "btn-light" : "theme-button-light"
				)}
				{...rest}
			>
				<FiEdit className="fs-3 fw-bold" />
			</button>
		);
	}

	if (!isEditing && data && hasSomeBlankField) {
		return <EditButton onClick={() => setIsEditing(true)} />;
	} else if (isEditing) {
		return <SaveButton onClick={handleUpdateData} />;
	}

	return null;
}
